export default {
	title: 'Loyalty Rewards',
	subTitle: 'Loyalty Rewards',
	content: [
		'These are rewards that your customers can use their point to redeem/purchase.',
		'Create the reward name, if you want it to run for a limited time select the start and end dates.',
    'Determine the points required to purchase this reward.',
    'You\'re done!'
	]
}



/** WEBPACK FOOTER **
 ** ./src/helpers/promotions/PromotionInfo.js
 **/